export const getCurrentTime = (dateStr) => {
  const date = dateStr ? new Date(dateStr) : new Date();

  return date.toLocaleString("en-US", {
    month: "short",   // e.g., "Jul"
    day: "numeric",   // e.g., "19"
    year: "numeric",  // e.g., "2025"
    hour: "2-digit",  // e.g., "02"
    minute: "2-digit",// e.g., "15"
    hour12: true      // AM/PM format
  });
};
